import React from 'react';
import { Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_FONT_BOLD, PDF_FONT_REGULAR } from '../../utils/pdfFontSetup';
import { renderHybridPdfText } from '../../utils/renderHybridPdfText';

const styles = StyleSheet.create({
  caption: {
    fontFamily: PDF_FONT_BOLD,
    fontSize: 11,
    marginTop: 4,
    marginBottom: 4,
    textAlign: 'left',
  },
  label: {
    fontFamily: PDF_FONT_BOLD,
  },
});

/**
 * Word-style table caption: "Table 1-1:" + tab + title (C-Caption, 12 pt bold).
 */
export default function PdfTableCaption({ label, title, style }) {
  if (!label) return null;
  const captionStyle = style ? [styles.caption, style] : styles.caption;
  return (
    <Text style={captionStyle} wrap>
      <Text style={styles.label}>{renderHybridPdfText(label, styles.label, 'cap-lbl-')}</Text>
      {'  '}
      {title ? renderHybridPdfText(title, captionStyle, 'cap-title-') : null}
    </Text>
  );
}
